import { useMemo } from 'react';
import { getCurrencySymbol } from '@restworld/utils-common';

import { CardWrapper, CardJpDetails, CardVenueDetails, WorkerBaseCardVariant } from './worker-base-card';

export function WorkerJpCard({
  restaurantLogo,
  restaurantName,
  publishedAt,
  city,
  redirectUrl,
  newTab,
  occupation,
  salaryMin,
  salaryMax,
  salary,
  salaryCurrency,
  salaryLabel,
  jobType,
  jobTitle,
  onClick,
  wrapperStyle,
  isJobPositionOutsideItaly,
  hasAlreadyApplied,
}: WorkerJpCardProps) {
  const variant: WorkerBaseCardVariant = 'jp';

  const currencySymbol = useMemo(() => getCurrencySymbol(salaryCurrency), [salaryCurrency]);

  const badges = useMemo(
    () =>
      [
        occupation || '',
        // Prefer the shared formatter's output (same text as the detail page: "€25k - 30k RAL",
        // "€1.500 - 1.600 netti mensili"); the raw numbers are a fallback for callers without it.
        salaryLabel ||
          (salaryMin && salaryMax
            ? `${currencySymbol}${salaryMin}-${salaryMax}`
            : salary
            ? `${currencySymbol}${salary}`
            : ''),
        jobType || '',
      ].filter(Boolean),
    [currencySymbol, jobType, occupation, salary, salaryLabel, salaryMax, salaryMin]
  );

  return (
    <CardWrapper variant={variant} href={redirectUrl} newTab={newTab} onClick={onClick} wrapperStyle={wrapperStyle}>
      <CardJpDetails badges={badges} title={jobTitle} />
      <CardVenueDetails
        variant={variant}
        logoSrc={restaurantLogo}
        city={city}
        firstSubDate={publishedAt}
        venueName={restaurantName}
        isOutsideItaly={isJobPositionOutsideItaly}
        hasAlreadyApplied={hasAlreadyApplied}
      />
    </CardWrapper>
  );
}

export interface WorkerJpCardProps {
  restaurantLogo: string;
  restaurantName?: string;
  publishedAt?: string;
  city?: string;
  redirectUrl?: string;
  newTab?: boolean;
  jobTitle?: string;
  occupation: string;
  salaryMin: string | number;
  salaryMax: string | number;
  salary?: string | number;
  salaryCurrency?: string;
  /** Pre-formatted salary (formatJobPositionSalary); wins over salaryMin/salaryMax/salary. */
  salaryLabel?: string;
  jobType: string;
  onClick?: () => void;
  wrapperStyle?: string;
  isJobPositionOutsideItaly?: boolean;
  hasAlreadyApplied?: boolean;
}
